<template>

  <div class="min-h-screen flex flex-col justify-between">
    
    <div class="flex flex-col flex-1 items-center justify-center -mt-36">
      
      <div class="bg-white rounded-xl shadow-md p-5 w-11/12 md:w-8/12 lg:w-5/12 xl:w-4/12 2xl:w-3/12">

        <div class="flex justify-center items-center">
          <a class="text-center" href="/">
            <img src="@/assets/img/logo.png" class="p-2.5 w-24 h-auto" />
          </a>
        </div>

        <div class="w-full flex flex-col my-4 text-center">
          <h3 class="text-xl font-weight-bolder text-gray-800">{{configuracionMeeting?.evento?.descripcion}}</h3>
          <h3 class="text-xl font-weight-bolder text-gray-500">{{configuracionMeeting?.descripcion}}</h3>
          <h3 class="text-xl font-weight-bolder text-gray-500 mt-3">{{ $t('label.inicio.sesion') }}</h3>
          <p class="text-base font-weight-bolder text-gray-400">{{ $t('label.ingresa.mail.contrasenia') }}</p>
        </div>

        <Form @submit="onSubmit" :validation-schema="schema">

          <div class="mb-4">
          <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText  v-bind="field" type="mail" placeholder="Mail" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="mail" />
              </span>
            </Field>          
          </div>

          <div class="mb-4">
            <Field name="password" v-slot="{ field, errors }" v-model="formData.password">
              <InputText  v-bind="field" type="password" placeholder="Contraseña" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="password" />
              </span>
            </Field>
          </div>

          <button type="submit" class="w-full text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>{{ $t('boton.ingresar') }}
          </button>

        </Form>
        
        <div class="w-full flex flex-col mt-8 text-center">
          <a @click="recuperarPassword" class="text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer">
            {{ $t('label.oblvide.password') }}
          </a>
          <a v-if="configuracionMeeting && configuracionMeeting?.habilitarRegistro" href="#" class="text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer">
            {{ $t('label.registrarme') }}
          </a>
        </div>
        
      </div>

      <div class="flex items-center gap-3 md:gap-4 my-6">
        <button @click="changeLanguage('es')" class="transition hover:scale-125 cursor-pointer">
          <img src="@/assets/img/ar.svg" class="h-6 md:h-8"/>
        </button>
        <button @click="changeLanguage('en')"  class="transition hover:scale-125 cursor-pointer">
          <img src="@/assets/img/us.svg" class="h-6 md:h-8"/>
        </button>
      </div>      

    </div>
  </div>
  
  <FullScreenLoader :visible="isSubmitting" />
  <RecuperarPasswordView v-if="recuperarPasswordVisible" :closeFunction="cerrarRecuperarPassword" />

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import FullScreenLoader from '../commons/FullScreenLoader.vue';
import RecuperarPasswordView from './private/modal/RecuperarPasswordView.vue';

import { Acreditado, ConfiguracionMeeting } from 'qreventos-suite/src/services/suite.interfaces';
import { RECHAZADO } from 'qreventos-suite/constantes';

import seguridadService from '@/services/seguridad.services';
import idiomaService from '@/services/idioma.services';
import meetingService from 'qreventos-suite/meeting';
import configuracionMeetingService from '@/services/configuracion.merting.services';
import suiteService from 'qreventos-suite/services';

export default defineComponent({
  components: {
    InputText, FullScreenLoader, RecuperarPasswordView,
    Field, ErrorMessage, Form
  },
  data() {
    return {
      isSubmitting: false,
      configuracionMeeting: undefined as unknown as ConfiguracionMeeting,
      recuperarPasswordVisible: false,
      formData: {
        mail: '',
        password: ''
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        mail: yup.string().required(this.$t('errors.ingrese.mail')).email(this.$t('errors.correo.invalido')),
        password: yup.string().required(this.$t('errors.ingrese.password')),
      });
    }
  },
  methods: {
    changeLanguage(lang: string) {
      this.$i18n.locale = lang;
      idiomaService.updateIdioma(lang);
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
        if (!this.configuracionMeeting.activo) {
          Swal.fire({ title: "Error", html: this.$t('label.modulo.deshabilitado'), icon: "error" });
          return;
        }

        const hash:string = await seguridadService.login(this.configuracionMeeting.evento.id, this.formData.mail, this.formData.password);
        if (hash) {
          const acreditado: Acreditado = await suiteService.findAcreditadoByHash(configuracionMeeting.evento.id, hash);
          if (acreditado.estadoAcreditado.id == RECHAZADO) {
            Swal.fire({ title: "Error", html: this.$t('label.acreditacion.rechazada'), icon: "error" });
            return;
          }

          this.$router.push({ path: '/private/dashboard' });
        }

      } catch (error) {        
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
        this.formData.password = '';
      } finally {
        this.isSubmitting = false;
      }
    },
    recuperarPassword() {
      this.recuperarPasswordVisible = true;
    },
    cerrarRecuperarPassword(ok:boolean = false) {
      this.recuperarPasswordVisible = false;
      if (ok) {
        Swal.fire({ title: this.$t('global.atencion'), html: this.$t('label.clave.enviada.exito'), icon: "success" });
      }
    }
  },
  async mounted() {
    const context = this.$route.params.context;

    try {
      this.isSubmitting = true;
      seguridadService.logout();

      this.configuracionMeeting = await meetingService.findByContext(context);
      if (this.configuracionMeeting) {
        configuracionMeetingService.save(this.configuracionMeeting);
      }
    } catch (error) {
      Swal.fire({ title: "Error", text: error + '', icon: "error" });
      this.isSubmitting = false;
    } finally {
      this.isSubmitting = false;
    }
  }
});
</script>
